import { render } from "./GitBook.vue?vue&type=template&id=79124cf0&scoped=true"
import script from "./GitBook.vue?vue&type=script&lang=js"
export * from "./GitBook.vue?vue&type=script&lang=js"

import "./GitBook.vue?vue&type=style&index=0&id=79124cf0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-79124cf0"

export default script